export type ToastConfig = {
  message: string;
  buttonLabel: string;
  buttonLink: string;
};

const HTTP_ERROR_TOAST_CONFIGS: Record<string, Partial<ToastConfig>> = {
  '400': {
    message: 'Oops! Something went wrong when saving the data',
  },
  '401': {
    message: 'Please log in again to access this page',
    buttonLabel: 'Login',
    buttonLink: '/sign_in',
  },
  '403': {
    message:
      "Sorry, but it looks like you don't have permission to perform that action",
  },
  '404': {
    message:
      "We're sorry, but the resource you're looking for could not be found",
  },
  '422': {
    message: 'Oops! There was a problem processing your request',
  },
};

export const getToastConfig = (statusCode: number | string): ToastConfig => {
  const defaultConfig = {
    message:
      "Oh no! We're experiencing some technical difficulties right now, please try again later",
    buttonLabel: 'Reload',
    buttonLink: window.location.href,
  };
  const toastConfig = HTTP_ERROR_TOAST_CONFIGS[statusCode.toString()];
  return { ...defaultConfig, ...toastConfig };
};
